// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oViN","left":"styles_left__2WYpE","desktopActions":"styles_desktopActions__2CvH_","title":"styles_title__DsHOa"};